import { t } from "i18next"
import { FormSection } from "../types/FormSection"
import { Action, Question, Section, SectionState } from "../types/SectionState"
import { normalizeSections } from "../utils/normalizeSections"

const INITIAL_SECTION_STATE = {}

export const setSections = (sections: FormSection[]): SectionState => {
  const normalizedSections = normalizeSections(sections)
  const reviewSection: Section = {
    completed: false,
    errors: false,
    name: t("client.sideNav.review"),
    order: Object.values(normalizeSections).length,
    questions: [],
    touched: false,
    conditional: false,
  }
  return { ...normalizedSections, reviewSection }
}

const resetSections = (state: SectionState) => {
  const sectionArray = Object.values(state)
  const newState = sectionArray.reduce((acc, curr) => {
    return {
      ...acc,
      [curr.name]: {
        name: curr.name,
        order: curr.order,
        completed: false,
        errors: false,
        touched: false,
        questions: curr.questions,
        conditional: curr.conditional,
      },
    }
  }, {})
  return newState
}

const setQuestion = (question: Question, state: SectionState): SectionState => {
  if (state[question.sectionName]) {
    const previousQuestions = state[question.sectionName].questions || []
    const newQuestions = [
      ...previousQuestions.map((prevQuestion) => {
        if (prevQuestion.fieldName === question.fieldName) {
          const newQuestion = {
            ...prevQuestion,
            touched: question.touched,
            error: question.error || false,
            displayValue: question.displayValue,
          }
          return newQuestion
        } else {
          return prevQuestion
        }
      }),
    ]
    const newState = {
      ...state,
      [question.sectionName]: {
        ...state[question.sectionName],
        completed: newQuestions
          .filter(({ optional }) => !optional)
          .filter(({ inputName }) => inputName !== "label")
          .every(
            ({ touched, error, displayValue }) =>
              (!touched && displayValue && !error) || (touched && !error),
          ),
        errors: newQuestions.some(({ error }) => error),
        touched: newQuestions.some(({ touched }) => touched),
        questions: newQuestions,
      },
    }
    return newState
  } else {
    return state
  }
}

const initialState: SectionState = INITIAL_SECTION_STATE

const reducer = (state: SectionState, action: Action): SectionState => {
  switch (action.type) {
    case "SET_QUESTION":
      return setQuestion(action.question, state)
    case "SET_SECTIONS":
      return setSections(action.sections)
    case "RESET_SECTIONS":
      return resetSections(state)
    default:
      return state
  }
}

export { initialState, reducer }
